import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-monthpicker', 'months', [
    'Sausis',
    'Vasaris',
    'Kovas',
    'Balandis',
    'Gegužė',
    'Birželis',
    'Liepa',
    'Rugpjūtis',
    'Rugsėjis',
    'Spalis',
    'Lapkritis',
    'Gruodis',
]);
Labels.set('ui-monthpicker', 'year', 'Metai');
Labels.set('ui-monthpicker', 'month', 'Mėnuo');
Labels.set('ui-monthpicker', 'clearDate', 'Pašalinti datą');
